import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AttachFileDialogComponent } from '../../../document-in-library/attach-file-dialog/attach-file-dialog.component';
import { AppService } from '../../../../app.service';
import { Department, PolicyDetailsVM, SiteCodes, WorkArea } from '../../../GET_NEW_UI/entities/global/model';
import { PolicyProcedureService } from '../../../GET_NEW_UI/services/policy-procedure.service';
import { MY_FORMATS } from '../../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { SafetyConfigService } from '../../services/safety-config.service';
import { FileReaderEvent } from '../../setup-implement/setup-implement.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-policy-procedure',
  templateUrl: './add-policy-procedure.component.html',
  styleUrls: ['./add-policy-procedure.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class AddPolicyProcedureComponent implements OnInit {

  constructor( private _appService: AppService,
    public dialog: MatDialog,
    private _safetyConfigService:SafetyConfigService,
    private _policyProcedureService :PolicyProcedureService, private _router:Router,
    private _notify: NotificationsService,   private _route: ActivatedRoute,private datepipe:DatePipe) { }

  PolicyId: number = 0;
  NewPolicyId: number = 0;
  
  StateList:SiteCodes[]=[];
  FileName:string=""
  SelectedDepartment:number[]=[];
  SelectedDepartment_=[];
  SelectedState_=[];
  SelectedState:number[]=[];
  SelectedWorkArea:number[]=[];
  SelectedWorkArea_=[];
  policyName:string=""
  note:string=""
  issuedDate:Date=null
  expiredDate:Date=null
  stateId:number=0
  NewFileName: string = "";
  Extension:string="";
  isSelectAllDepartment:boolean=false
  isSelectAllState:boolean=false
  isSelectAllWorkArea:boolean=false
  isSavedEnable:boolean=true
  FilePreview:string="";
  allworklist:WorkArea[]=[];
  filteredWorkList:WorkArea[]=[];
  allDepartmentList:Department[]=[];
  filteredwDepartmentlist:Department[]=[];

  ngOnInit() {
    this._appService.setPageTitle('Upload Polices and Procedures');
    this.PolicyId = +this._route.snapshot.paramMap.get('PolicyId');
    this.getStateList();
    this.getAllDepartmentAndWorkAreaList();
    if(this.PolicyId>0){
      this._policyProcedureService.getPolicyProcedureDetail(this.PolicyId).subscribe(res=>{      
     this.policyName=res.PolicyName;
     this.note=res.Note;
     this.issuedDate=res.IssuedDate;
     this.expiredDate=res.ExpiredDate;
     this.SelectedState=res.StateIds;
     this.SelectedState_=res.StateIds; 
     this.SelectedDepartment=res.DepartmentIds; 
     this.SelectedDepartment_=res.DepartmentIds;
     this.SelectedWorkArea=res.WorkAreaIds;
     this.SelectedWorkArea_=res.WorkAreaIds;
     this.FilePreview=res.Attachment;
     this.FileName=res.FileName;
     this.loadDepartmentAndWorkArea();
      });
      
    } 


  }
  
  loadDepartmentAndWorkArea(){
      this.filteredwDepartmentlist = this.allDepartmentList.filter((el) => {
        return this.SelectedState_.some((f) => {
          return f === el.SiteId;
        });
      })
      this.filteredWorkList = this.allworklist.filter((el) => {
        return this.SelectedDepartment_.some((f) => {
          return f === el.DepartmentID;
        });
      }); 
    }

  getAllDepartmentAndWorkAreaList(){
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    this.allDepartmentList=res.Departments;
    this.allworklist=res.WorkAreas; 
    if(this.PolicyId>0) { 
      this.loadDepartmentAndWorkArea();
    }
    })
  }

  getStateList(){
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
      { 
        this.StateList=sites;      
      });
  }

  onClickDownloadForm() {

      var newstring = this.FilePreview.slice(1);

      let _newstring = newstring.substring(0, newstring.length - 1);

      var arrBuffer = this.base64ToArrayBuffer(this.FilePreview);
        var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = this.FileName + '.pdf';
        link.click();
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

   onFileChanged(event) {

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.NewFileName = event.target.files[0].name;
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var fileUrl = (event.target["result"]);
        this.FilePreview = fileUrl;
      }
    }

  }

   savePolicyProcedure(){
    if(this.isSavedEnable==true){
 
    if(this.SelectedState.length<=0){  
      this._notify.error('Please Select State')
      }
      else if(this.SelectedDepartment.length<=0){
        this._notify.error('Please Select Department')
      }
      else if(this.SelectedWorkArea.length<=0){
        this._notify.error('Please Select Work Area')
      }
      else if(this.policyName==""){
        this._notify.error('Please Enter Form Header #')
      }
      else if(this.issuedDate==null){
        this._notify.error('Please Enter Issued Date')
      }   
      else{
        
    this.SelectedDepartment=this.SelectedDepartment_
    this.SelectedWorkArea=this.SelectedWorkArea_
    this.SelectedState=this.SelectedState_
    let model= new  PolicyDetailsVM();
    model.PolicyId = 0;
    model.PolicyName=this.policyName;
    model.Note=this.note;
    if (this.FilePreview) {
      var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
      sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
      model.Attachment = this.FilePreview;
      model.FileName = this.NewFileName;
    }
    let issuedate= this.datepipe.transform(this.issuedDate, 'yyyy-MM-dd')
    model.IssuedDate= new Date(issuedate);
    let expirydate= this.datepipe.transform(this.expiredDate, 'yyyy-MM-dd')
    model.ExpiredDate=this.expiredDate !=null?new Date(expirydate):null;
    model.StateIds=this.SelectedState
    model.DepartmentIds=this.SelectedDepartment
    model.WorkAreaIds=this.SelectedWorkArea
    model.CreatedDate=new Date();
    
    this._policyProcedureService.savePolicyProcedure(model).subscribe(PId=>{
      if(PId>0)
      {
        this.isSavedEnable=false
        this._notify.success('Policy Successfully Added');
        this.NewPolicyId=PId
        this.NavigateToSearch();
      }
      else{    
          this._notify.error('An error occurred please check the data');       
      }
    })

 }
}
else{
  this._notify.error('An error occurred PolicyId already exists'); 
}
 }

 updatePolicyProcedure()
   {

let model =new PolicyDetailsVM();
model.PolicyId=this.PolicyId;
model.StateIds=this.SelectedState;
model.DepartmentIds=this.SelectedDepartment;
model.WorkAreaIds=this.SelectedWorkArea;
model.PolicyName=this.policyName;
model.Note=this.note;
let issuedate= this.datepipe.transform(this.issuedDate, 'yyyy-MM-dd');
model.IssuedDate= new Date(issuedate);
model.ExpiredDate= this.expiredDate !=null?new Date(this.datepipe.transform(this.expiredDate, 'yyyy-MM-dd')):null;
if (this.NewFileName) {
  var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
  sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
  model.Attachment = this.FilePreview;
  model.FileName = this.NewFileName;
}
this._policyProcedureService.updatePolicyProcedure(model).subscribe(res=>{
  if(res>0){
   this._notify.success('Successfully Updated');
   this.NavigateToSearch();
   }
  })

}

  ResetFields(){
    this.SelectedState=[];
    this.SelectedDepartment =[];
    this.SelectedWorkArea =[];
    this.issuedDate=null;
    this.expiredDate=null;
    this.policyName="";
    this.note="";  
    this.FileName="";
    this.FilePreview="";
  }

  buildStateFormControl = new FormControl("", [Validators.required]);
  buildDepartmentFormControl = new FormControl("", [Validators.required]);
  buildnoFormControl = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.buildnoFormControl.hasError("required") ? "You must enter a value" : "";
  }

  selectAllState(ev) {
    let  arr=[]
     this.isSelectAllState = !this.isSelectAllState;
     if(this.isSelectAllState){
       for(let i=0; i<this.StateList.length; i++){
         arr.push(this.StateList[i].Id)
       } 
          this.buildStateFormControl.setValue(arr);
     } 
     else{
       this.buildStateFormControl.setValue([]);
       this.SelectedDepartment =[];
     }   
      this.SelectedState_=this.buildStateFormControl.value
      
      this.filteredwDepartmentlist = this.allDepartmentList.filter((el) => {
        return this.SelectedState_.some((f) => {
          return f === el.SiteId;
        });
      });
   };
 
   selectAllDepartment(ev) {
    let  arr=[]
     this.isSelectAllDepartment = !this.isSelectAllDepartment;
     if(this.isSelectAllDepartment){
       for(let i=0; i<this.filteredwDepartmentlist.length; i++){
         arr.push(this.filteredwDepartmentlist[i].ID)
       } 
          this.buildDepartmentFormControl.setValue(arr);
     } 
     else{
       this.buildDepartmentFormControl.setValue([]);
       this.SelectedWorkArea =[];
     }   
      this.SelectedDepartment_=this.buildDepartmentFormControl.value
      
      this.filteredWorkList = this.allworklist.filter((el) => {
        return this.SelectedDepartment_.some((f) => {
          return f === el.DepartmentID;
        });
      });
   };

   selectAllWorkArea(ev) {
    let  arr=[]
     this.isSelectAllWorkArea = !this.isSelectAllWorkArea;
     if(this.isSelectAllWorkArea){
       for(let i=0; i<this.filteredWorkList.length; i++){
         arr.push(this.filteredWorkList[i].ID)
       } 
          this.buildnoFormControl.setValue(arr);
     } 
     else{
       this.buildnoFormControl.setValue([]);
     }   
      this.SelectedWorkArea_=this.buildnoFormControl.value
   }

   stateChange(ID: number) {
    if (this.SelectedState_.indexOf(ID) > -1) {
      const pos = this.SelectedState_.indexOf(ID);
      this.SelectedState_.splice(pos, 1);
      const removeStateDeptList=this.filteredwDepartmentlist.filter(x=>x.SiteId==ID);
      for(let i = 0; i < removeStateDeptList.length; i++) {
        if (this.SelectedDepartment.indexOf(removeStateDeptList[i].ID) > -1){
          const position = this.SelectedDepartment.indexOf(removeStateDeptList[i].ID);
          this.SelectedDepartment.splice(position, 1);
        }
        }
    } else {
      this.SelectedState_.push(ID);
    }
    this.filteredwDepartmentlist = this.allDepartmentList.filter((el) => {
      return this.SelectedState_.some((f) => {
        return f === el.SiteId;
      });
    });
    this.SelectedWorkArea =[];
    this.filteredWorkList = [];
  }
   
   departmentChange(ID: number) {
    if (this.SelectedDepartment_.indexOf(ID) > -1) {
      const pos = this.SelectedDepartment_.indexOf(ID);
      this.SelectedDepartment_.splice(pos, 1);
      const removeDeptWorkAreaList=this.filteredWorkList.filter(x=>x.DepartmentID==ID.toString());
      for(let i = 0; i < removeDeptWorkAreaList.length; i++) {
        if (this.SelectedWorkArea.indexOf(removeDeptWorkAreaList[i].ID) > -1){
          const position = this.SelectedWorkArea.indexOf(removeDeptWorkAreaList[i].ID);
          this.SelectedWorkArea.splice(position, 1);
        }
        }
    } else {
      this.SelectedDepartment_.push(ID);
    }
    this.filteredWorkList = this.allworklist.filter((el) => {
      return this.SelectedDepartment_.some((f) => {
        return f === el.DepartmentID;
      });
    });
  }

   workAreaChange(ID: number) {
    if (this.SelectedWorkArea_.indexOf(ID) > -1) {
      const pos = this.SelectedWorkArea_.indexOf(ID);
      this.SelectedWorkArea_.splice(pos, 1);
    } else {
      this.SelectedWorkArea_.push(ID);
    }
  }

    NavigateToSearch(){
      this._router.navigate(['/search-policies-procedures']);
      }

      openAttachDoc()
  {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      data: { 
        NewFileName:this.NewFileName,
        FilePreview:this.FilePreview
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log("res",res)
      if (res !=false) {
        this.FilePreview=res.FilePreview; 
        this.NewFileName=res.NewFileName;
        this.Extension=res.Extension;
        
      }
   
    });
    
  }
}

